import { alpha, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../theme/colors';

export const useTimelineIconStyles = makeStyles<Theme, { color?: string }>(() => ({
  avatar: {
    backgroundColor({ color }) {
      return color ? alpha(color, 0.15) : alpha(Colors.bookedScannedInProgressGray, 0.15);
    }
  },
  icon: {
    width: '24px',
    height: '24px',
    color({ color }) {
      return color;
    }
  }
}));
